import React from 'react';
import {
  AlertDialog, AlertDialogAction, AlertDialogCancel, AlertDialogContent,
  AlertDialogDescription, AlertDialogFooter, AlertDialogHeader, AlertDialogTitle, AlertDialogTrigger,
} from './ui/alert-dialog';
import { Trash2 } from 'lucide-react';

export const ConfirmDelete = ({ testId, label, onConfirm }) => (
  <AlertDialog>
    <AlertDialogTrigger asChild>
      <button data-testid={testId} onClick={(e) => e.stopPropagation()} className="text-[#9A8AAF] hover:text-[#43265E] transition-colors shrink-0" aria-label="Delete">
        <Trash2 className="w-5 h-5" strokeWidth={1.5} />
      </button>
    </AlertDialogTrigger>
    <AlertDialogContent className="bg-[#FBFAF8] rounded-sm">
      <AlertDialogHeader>
        <AlertDialogTitle className="font-display text-2xl text-[#241033]">Are you sure?</AlertDialogTitle>
        <AlertDialogDescription className="font-light text-[#4A4453]">This will permanently delete {label}. This can’t be undone.</AlertDialogDescription>
      </AlertDialogHeader>
      <AlertDialogFooter>
        <AlertDialogCancel data-testid="confirm-delete-cancel" className="rounded-full">Cancel</AlertDialogCancel>
        <AlertDialogAction data-testid="confirm-delete-confirm" onClick={onConfirm} className="btn-plum rounded-full">Delete</AlertDialogAction>
      </AlertDialogFooter>
    </AlertDialogContent>
  </AlertDialog>
);
